export const MAX_MULTI_DAY_EVENTS_PER_DAY = 1;
export const LIST_TRUNCATE_EVENTS_MAX = 6;